import React from "react";
import "./Loading.css";

export const Loading = () => {
  return <div className="loader">Loading...</div>;
};
export default Loading;